import { useEffect, useState } from 'react';

import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

import ContentService from '../../../services/contentService';
import { SectionDataWithProgress } from '../../../types/compound/progressTypes';
import { ContentType } from '../../../types/contentTypes';
import SectionData from '../../../types/SectionData';
import SkillData from '../../../types/skillData';
import ContentTypeIconList from '../content-type-icon-list/ContentTypeIconList';

import './SectionRow.scss';

interface SectionRowProps {
  section: SectionDataWithProgress | SectionData;
  skill: SkillData;
  editing?: boolean;
  className?: string;
}

export default function SectionRow({ section, skill, editing = false, className = '' }: SectionRowProps) {
  const [contentTypes, setContentTypes] = useState<ContentType[]>();

  const toLink = editing
    ? `/skills/${skill.slug}/sections/${section.slug}/contents/edit`
    : `/skills/${skill.slug}/sections/${section.slug}`;

  useEffect(() => {
    async function fetchContent() {
      const data = await ContentService.getUniqueContentTypesBySectionID(section.id);
      setContentTypes(data);
    }

    fetchContent();
  }, [section.id]);

  return (
    <Link
      className={`section-row flex items-center justify-between ${
        'complete' in section && section.complete ? 'complete' : ''
      } ${className} `}
      to={toLink}
    >
      <span className="name">{section.name}</span>
      {'complete' in section && section.complete && (
        <Icon className="check ml-auto mr-2" icon="material-symbols:done" />
      )}
      {contentTypes && <ContentTypeIconList contentTypes={contentTypes} />}
    </Link>
  );
}
